import React, {useEffect, useState} from 'react';
import {getTermsPaged} from "../../services/TermRepository";
import {CMSHeader} from "./CMSHeader";
import {TermGridElement} from "./TermGridElement";

export function TermAdmin() {

    const [terms, setTerms] = useState([]);
    const [page, setPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);


    useEffect(() => {
        getTermsPaged(page).then(result => {
            setTerms(result.content)
            setTotalPages(result.totalPages)
        }).catch(err => console.log(err.message))
    }, [page]);

    return (
        <div>

            <CMSHeader page={page} maxPage={totalPages} setPage={setPage} context={"Begreper"}/>
            <div className={"container pt-3"}>
                {
                    terms.map(term => (
                       <TermGridElement term={term}/>
                    ))
                }
            </div>
        </div>


    );

}